module.exports = __webpack_public_path__ + "static/media/iStock-1263999064.db5e392f.jpg";